import * as mutationTypes from './mutation-types'

import { filterItems, prepareData } from './helpers'

const Companies = {
  state() {
    return {
      data: [],
    }
  },

  getters: {
    processedCompanies: ({ data }, _getters, _rootState, { currentQuery }) => {
      return filterItems(data, currentQuery)
    },
    allCompanies: ({ data }, _, { dataLoaded }, { currentQuery }) => {
      if (!dataLoaded) {
        return []
      }

      if (!currentQuery || currentQuery === '') {
        const normalizedData = data.map(function (el) {
          return {
            ...el,
            unread_notifications_count: el.unread_notifications_count || 0,
          }
        })

        const sortedData = normalizedData.sort(function (a, b) {
          // sort by number of notifications count (desc)
          if (a.unread_notifications_count > b.unread_notifications_count) {
            return -1
          }
          if (a.unread_notifications_count < b.unread_notifications_count) {
            return 1
          }

          // then by slugName (asc)
          if (a.slugName > b.slugName) {
            return 1
          }
          if (a.slugName < b.slugName) {
            return -1
          }

          return 0
        })

        return sortedData
      } else {
        return filterItems(data, currentQuery)
      }
    },
  },

  mutations: {
    [mutationTypes.SET_COMPANIES_DATA](state, data) {
      state.data = prepareData(data, 'Company')
    },
  },

  actions: {
    fetchAllCompaniesData({ commit, rootState }) {
      commit(mutationTypes.SET_DATA_LOADING, true)

      window.$.ajax({
        url: Silverfin.Routes.quick_search_companies_path({
          firm_id: rootState.currentFirmId,
          company_id: rootState.currentCompanyId,
        }),
        success: (items) => {
          commit(mutationTypes.SET_DATA_LOADING, false)
          commit(mutationTypes.SET_DATA_LOADED)
          commit(mutationTypes.SET_COMPANIES_DATA, items.companies)
        },
      })
    },
  },
}

export default Companies
